import { render, staticRenderFns } from "./StudentSozoSubject.vue?vue&type=template&id=4d7b6ba4&scoped=true&lang=pug&"
import script from "./StudentSozoSubject.vue?vue&type=script&lang=ts&"
export * from "./StudentSozoSubject.vue?vue&type=script&lang=ts&"
import style0 from "./StudentSozoSubject.vue?vue&type=style&index=0&id=4d7b6ba4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7b6ba4",
  null
  
)

export default component.exports